import { ListService } from "@/modules/List/services/ListService";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import { Http } from "@status/codes";
import { AxiosError } from "axios";
import { Vue } from "vue-property-decorator";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { GENERAL_RULES_CONSTANTS } from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import { UserService } from "@/modules/User/services/UserService";
import { USER_ACCESS } from "@/modules/User/constants/UserConstants";
import { UserQuery } from "@/modules/User/models/UserQuery";
import { CupsPriceLevelService } from "@/modules/CupsPriceLevels/services/CupsPriceLevelService";
import { CUPS_ACCESS } from "@/modules/CupsPriceLevels/constants/CupsPriceLevelConstants";
import {
  FilterField,
  FilterOfCollection
} from "@/modules/DashboardTemplate/models/FilterOfCollection";
import { SectionOfDashboard } from "@/modules/DashboardTemplate/models/SectionOfDashboard";
import { FIELD_WITHOUT_DATA } from "@/modules/DashboardTemplate/constants/DashboardTemplatesConstants";

export abstract class ListOfPropertiesValues extends Vue {
  abstract loadItems(
    field: string,
    idList?: string,
    keyword?: string,
    lastDocId?: string
  ): Promise<{ data: DynamicSelectData[]; lastDocId?: string }>;

  abstract setIndexes(
    indexSectionOfDashboard: number,
    indexCollectionFilter: number
  ): void;

  async getList(idList: string): Promise<{ data: DynamicSelectData[] }> {
    try {
      const listService = new ListService();
      const listResponse = await listService.getListById(idList);
      if (listResponse.code === Http.Found) {
        const dataList = (listResponse.data?.options.map(item => ({
          id: item.value,
          name: item.title
        })) as unknown) as DynamicSelectData[];

        dataList.push(FIELD_WITHOUT_DATA);
        return {
          data: dataList
        };
      }
      return { data: [] };
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      return { data: [] };
    }
  }

  async getUserByQuery(
    setFilters: (ref: string, name: string) => { UserQuery: UserQuery },
    name?: string
  ) {
    try {
      console.log("name", name);

      if (!name) return { data: [] };

      const filterQuery = setFilters(
        GENERAL_RULES_CONSTANTS.ID_REFERENCE,
        name
      );

      const userService = new UserService();
      const response = await userService.getUserByFilters(
        filterQuery as UserQuery
      );
      console.log("resp", response);

      if (response.code !== Http.Found || !response.data) {
        Snackbar.popInfo(response.message);
        return { data: [] };
      }
      const users = response.data.userArray;
      const userList: DynamicSelectData[] = [];
      users.forEach(item => {
        const user =
          item.name && item.name != "" ? item.name : item.userDocument ?? "";
        userList.push({
          id: item.id,
          name: user
        });
      });
      console.log("userList", userList);

      return { data: userList };
    } catch (error) {
      console.log("---->", error);

      if ((error as AxiosError).response?.status == Http.Forbidden)
        return Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + USER_ACCESS.GET
        );
      else return Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getCups() {
    try {
      const cupsPriceLevelService = new CupsPriceLevelService();
      const responseData = await cupsPriceLevelService.getAllActiveCupsPriceLevel();
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const serviceCups = responseData.data;
        const serviceCupsList: DynamicSelectData[] = [];
        serviceCups.forEach(cup => {
          serviceCupsList.push({
            id: cup.id,
            name: `${cup.cups} - ${cup.externalName}`,
            fields: cup.clients
          });
        });
        return { data: serviceCupsList };
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + CUPS_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getPriceLevels(
    sectionsOfDashboardStore: SectionOfDashboard[],
    indexSectionOfDashboard: number,
    indexCollection: number
  ) {
    const fieldFound: FilterOfCollection = sectionsOfDashboardStore[
      indexSectionOfDashboard
    ].collections[indexCollection].filters.find(
      (item: FilterOfCollection) =>
        (item.field as FilterField[])[0].id == "cups"
    ) as FilterOfCollection;
    const values: DynamicSelectData[] = [];

    fieldFound.value.forEach((item: DynamicSelectData) => {
      Object.entries(item.fields).forEach(([key, value]) => {
        const item = value as { name: string; price: string };
        values.push({
          id: key,
          name: item.name + " - " + item.price
        });
      });
    });

    return { data: values };
  }
}
